// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-file-print {
  display: none;
}

@page {
  size: A4 portrait;
  margin: 12mm;
}

@media print {
  .clinical-main__scroll:has(.patient-file-print) .patient-profile {
    display: none !important;
  }

  .patient-file-print {
    display: block !important;
    box-sizing: border-box;
    width: 100%;
    color: #0f172a;
    background: #ffffff;
    font-size: 10pt;
    line-height: 1.4;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .patient-file-print * {
    box-shadow: none !important;
  }

  .patient-file-print__header {
    margin: 0 0 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e2e8f0;
    page-break-after: avoid;
  }

  .patient-file-print__kicker {
    margin: 0;
    font-size: 8pt;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94a3b8;
  }

  .patient-file-print__header h1 {
    margin: 2px 0 0;
    font-size: 18pt;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: #0f172a;
  }

  .patient-file-print__meta {
    margin: 2px 0 0;
    font-size: 9pt;
    color: #64748b;
  }

  .patient-file-print__section {
    display: block;
    margin: 0 0 14px;
  }

  .patient-file-print__section--page {
    break-before: page;
    page-break-before: always;
  }

  .patient-file-print__section > h2,
  .patient-file-print__section > h3 {
    margin: 0 0 8px;
    color: #0f172a;
    page-break-after: avoid;
  }

  .patient-file-print__section > h2 {
    font-size: 16pt;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.2;
    padding-bottom: 4px;
    border-bottom: 2px solid #0f172a;
  }

  .patient-file-print__section > h3 {
    margin-top: 14px;
    font-size: 13pt;
    font-weight: 700;
    line-height: 1.2;
    color: #0f172a;
  }

  .patient-file-print__balance {
    margin: 0 0 6px;
    font-size: 11pt;
    font-weight: 700;
    color: #0f172a;
  }

  .patient-file-print__balance span {
    margin-inline-end: 6px;
    font-size: 8pt;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #64748b;
  }

  .patient-file-print__empty {
    margin: 0;
    color: #64748b;
  }

  .patient-file-print table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }

  .patient-file-print table + table {
    margin-top: 8px;
  }

  .patient-file-print thead {
    display: table-header-group;
  }

  .patient-file-print tr {
    page-break-inside: avoid;
  }

  .patient-file-print th,
  .patient-file-print td {
    padding: 5px 8px;
    border-bottom: 1px solid #e2e8f0;
    text-align: start;
    vertical-align: top;
  }

  .patient-file-print thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 8pt;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .patient-file-print td {
    color: #334155;
    font-size: 9.5pt;
  }

  .patient-file-print__facts th {
    width: 16%;
    background: transparent;
    color: #64748b;
    font-size: 8pt;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .patient-file-print__facts td {
    width: 34%;
    color: #0f172a;
    font-weight: 600;
  }

  .patient-file-print__clinical td {
    white-space: pre-wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowPatient/components/FileSummary/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".patient-file-print {\n  display: none;\n}\n\n@page {\n  size: A4 portrait;\n  margin: 12mm;\n}\n\n@media print {\n  .clinical-main__scroll:has(.patient-file-print) .patient-profile {\n    display: none !important;\n  }\n\n  .patient-file-print {\n    display: block !important;\n    box-sizing: border-box;\n    width: 100%;\n    color: #0f172a;\n    background: #ffffff;\n    font-size: 10pt;\n    line-height: 1.4;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .patient-file-print * {\n    box-shadow: none !important;\n  }\n\n  .patient-file-print__header {\n    margin: 0 0 14px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e2e8f0;\n    page-break-after: avoid;\n  }\n\n  .patient-file-print__kicker {\n    margin: 0;\n    font-size: 8pt;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #94a3b8;\n  }\n\n  .patient-file-print__header h1 {\n    margin: 2px 0 0;\n    font-size: 18pt;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n    color: #0f172a;\n  }\n\n  .patient-file-print__meta {\n    margin: 2px 0 0;\n    font-size: 9pt;\n    color: #64748b;\n  }\n\n  .patient-file-print__section {\n    display: block;\n    margin: 0 0 14px;\n  }\n\n  .patient-file-print__section--page {\n    break-before: page;\n    page-break-before: always;\n  }\n\n  .patient-file-print__section > h2,\n  .patient-file-print__section > h3 {\n    margin: 0 0 8px;\n    color: #0f172a;\n    page-break-after: avoid;\n  }\n\n  .patient-file-print__section > h2 {\n    font-size: 16pt;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    line-height: 1.2;\n    padding-bottom: 4px;\n    border-bottom: 2px solid #0f172a;\n  }\n\n  .patient-file-print__section > h3 {\n    margin-top: 14px;\n    font-size: 13pt;\n    font-weight: 700;\n    line-height: 1.2;\n    color: #0f172a;\n  }\n\n  .patient-file-print__balance {\n    margin: 0 0 6px;\n    font-size: 11pt;\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .patient-file-print__balance span {\n    margin-inline-end: 6px;\n    font-size: 8pt;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #64748b;\n  }\n\n  .patient-file-print__empty {\n    margin: 0;\n    color: #64748b;\n  }\n\n  .patient-file-print table {\n    width: 100%;\n    border-collapse: collapse;\n    page-break-inside: auto;\n  }\n\n  .patient-file-print table + table {\n    margin-top: 8px;\n  }\n\n  .patient-file-print thead {\n    display: table-header-group;\n  }\n\n  .patient-file-print tr {\n    page-break-inside: avoid;\n  }\n\n  .patient-file-print th,\n  .patient-file-print td {\n    padding: 5px 8px;\n    border-bottom: 1px solid #e2e8f0;\n    text-align: start;\n    vertical-align: top;\n  }\n\n  .patient-file-print thead th {\n    background: #f8fafc;\n    color: #64748b;\n    font-size: 8pt;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  .patient-file-print td {\n    color: #334155;\n    font-size: 9.5pt;\n  }\n\n  .patient-file-print__facts th {\n    width: 16%;\n    background: transparent;\n    color: #64748b;\n    font-size: 8pt;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  .patient-file-print__facts td {\n    width: 34%;\n    color: #0f172a;\n    font-weight: 600;\n  }\n\n  .patient-file-print__clinical td {\n    white-space: pre-wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
